/*
MODIFICATION IS PROVIDED BY SEARCHANISE TEAM. WITH ANY QUESTIONS, CONTACT US AT feedback@searchanise.io

The modification allows showing custom content in the Instant search widget before the user types search query. 

For the modification to work, make sure the "Show popular suggestions on click" option is enabled in your app admin panel > Search & Navigation > Instant search widget > Content tab. 

You can specify what content will be displayed for Products, Categories and Pages sections.

If you need to disable the modification, find the variable isEnabled in the Settings section and change its value to false, so it looks like that:

let isEnabled = false;

PRODUCTS

The list of the products depends on the tag specified in the productTag variable. 
You can change what products are displayed in the widget by adding/removing the corresponding tag from the products information in your admin panel. 
You can also change the tag the modification uses. Please make sure the tag is enclosed in quote marks. 

Here is an example of how it should look like: 

let productTag = "featured-search";

COLLECTIONS

Collections that will be displayed are controlled by the fixedCollectionsList variable.
The variable contains the list of the pairs, each pair specifies the collection name and its link. 
There are a few important formatting rules to follow: 

1. Make sure that your collections names and links are enclosed in quote marks. 
2. Collection name and collection link should be devided by a column. 
3. Each pair should be closed by a comma. 

Here is an example of the correct fomatting: 

let fixedCollectionsList = { 
    "Collection 1": "/collections/collection1",
    "Collection 2": "/collections/collection2",
}

PAGES

Information about the pages that will be displayed is specified in the fixedPagesList variable. 
The structure of the variable is similar to the one of the collections and follows the same rules. 
The variable includes the list of the pair, each pair specifies the name of the page and its link. 

Here is an example of the correctly populated fixedPagesList variable: 

let fixedPagesList = {
    "Page 1": "https://taosfootwear.com/pages/page1",
    "Page 2": "https://taosfootwear.com/pages/page2",
}

*/

// SETTINGS

let productTag = "Best Seller"
var isStatus = false;
if(document.querySelector("#searchanise-collection")){
    productTag = document.querySelector("#searchanise-collection").value;
}
let fixedCollectionsList = { 
    "Sneakers with Arch Support": "/collections/sneakers",
    "Boots": "/collections/boots",
    "Wool": "/collections/clogs",
}

let fixedPagesList = {
    "What size am I?": "https://help.taosfootwear.com/en-US/what-size-am-i-19053",
    "About Taos": "https://taosfootwear.com/pages/about-taos",
    "Activate Your Warranty": "https://taosfootwear.com/pages/warranty-activation"
}

let isEnabled = true;

// SETTINGS END
// DO NOT MODIFY THE CODE BELOW

document.addEventListener('Searchanise.Loaded', function() {
    (function($) {

        if (!isEnabled || isEnabled === 'false') { return }
        let fixedProductsSearchRequest = `https://searchserverapi1.com/getresults?api_key=1J9E4w4u8m&sortBy=title&sortOrder=desc&items=true&facets=false&restrictBy[tags]=${productTag},MASTER&maxResults=250`;

        let fixedProductsList = [];
        let autcompleteSectionsOrder = Searchanise.GetWidgets().options.AutocompleteResultsOrder;

        async function showFixedProducts(container, input) {
            if (!productTag) { return }
            
            if (!fixedProductsList.length) {
                $('.snize-ac-results-content:not(.hidden)').addClass('hidden');
                await $.get(fixedProductsSearchRequest, function(data) {
                    fixedProductsList = JSON.parse(data).items;
                });
            }
            
            $('.snize-ac-results-content.hidden').removeClass('hidden');

            if (!input.prop('value')) {
                $('#snize-ac-items-container-4').removeClass("not-empty");
                $("#snize-ac-items-container-4").addClass("feature-collection-new");
                $('#snize-ac-items-container-4').addClass("searchanise-swiper");

                if ($('#snize-ac-items-container-4 .swiper-wrapper').length) {
                  $('#snize-ac-items-container-4 .swiper-wrapper').remove();
                  $('#snize-ac-items-container-4 .carousel-controls').remove();
                  $('#snize-ac-items-container-4 .swiper-notification').remove();
                }

                $('#snize-ac-items-container-4', container).append("<div class='swiper-wrapper'></div>");
                $('.snize-no-products-found').remove();
                if (!$('#snize-ac-items-container-4 .snize-label', container).length) {
                    $('#snize-ac-items-container-4', container).prepend(`<li class="snize-label">TRENDING PRODUCTS</li>`);
                }
                // alert(fixedProductsList.length);
                const collectionProducts = document.querySelector(".searchanise_collection");
                if (collectionProducts.children.length > 0) {
                  document.querySelector("#snize-ac-items-container-4 .swiper-wrapper").innerHTML = collectionProducts.innerHTML;
                }else{
                  fixedProductsList.forEach((item) => {
                      if (window.innerWidth < 821 && $('.snize-product', container).length == Searchanise.GetWidgets().options.AutocompleteItemCount) {
                          return;
                      }
                      if (window.innerWidth > 1024) {
                          $('.swiper-wrapper', container).addClass('snize-custom-product-suggestions').append(
                          `<li class="snize-product swiper-slide" id="snize-ac-product-${item.product_id}" style="cursor: pointer;"><a href=${item.link} class="snize-item" draggable="false"><div class="snize-thumbnail"><img src=${item.image_link} class="snize-item-image " alt="${item.title}"></div><span class="snize-title">${item.title}</span><span class="snize-description" style="max-height: 2.8em; -webkit-line-clamp: 2;">${item.description}</span><div class="snize-price-list"><span class="snize-price snize-price-with-discount money ">${Searchanise.GetWidgets().formatPrice(item.price)}</span></div></a></li>`);
                      } else {
                          $('.swiper-wrapper', container).append(
                          `<li class="snize-product swiper-slide" id="snize-ac-product-${item.product_id}" style="cursor: pointer;"><a href="${item.link}" class="snize-item"><div class="snize-thumbnail"><img src="${item.image_link}" class="snize-item-image " alt="${item.title}"></div><div class="snize-product-info"><span class="snize-title">${item.title}</span><span class="snize-description" style="max-height: 2.8em; -webkit-line-clamp: 2;">${item.description}</span><div class="snize-ac-prices-container"><div class="snize-price-list"><span class="snize-price snize-price-with-discount money theme-money ">${Searchanise.GetWidgets().formatPrice(item.price)}</span></div></div></div></a></li>`);
                      }
                  });
                }
                $('.snize-ac-results-columns', container).removeClass('snize-hidden');
                $('.swiper-wrapper', container).removeClass('snize-hidden');
                $('#snize-ac-items-container-4', container).removeClass('snize-hidden');
            } else {
                 $('#snize-ac-items-container-4').addClass("not-empty");
                $('.swiper-wrapper', container).removeClass('snize-custom-product-suggestions');
            }

             $("#snize-ac-items-container-4").append(`<div class="carousel-controls">
                        <div class="carousel-scrollbar"></div>
                        <div class="carousel__pager">
                        <button class="pager-prev" data-previous="" aria-label="Previous Carousel Slide"> 
                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
                            <path d="M7.29565 0.662109L0.957626 7.00014L7.29565 13.3382" stroke="black" stroke-width="1.01409" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                        <button class="pager-next" data-next="" aria-label="Next Carousel Slide">
                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
                            <path d="M1.07739 0.662109L7.41542 7.00014L1.07739 13.3382" stroke="black" stroke-width="1.01409" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                        </div>
                    </div>`);
                
                searchSwiperSlider();
        }

        // valid section options: "categories", "pages"
        function showFixedSection(container, input, section) {
            let fixedList, sectionLabel, sectionNumber, elementClass;
            switch (section) {
                case 'categories':
                    fixedList = fixedCollectionsList; 
                    sectionLabel = Searchanise.GetWidgets().options.LabelAutocompleteCategories;
                    elementClass = 'category';
                    sectionNumber = autcompleteSectionsOrder.indexOf('categories');
                    break;
                case 'pages':
                    fixedList = fixedPagesList; 
                    sectionLabel = Searchanise.GetWidgets().options.LabelAutocompletePages;
                    elementClass = 'page';
                    sectionNumber = autcompleteSectionsOrder.indexOf('pages');
                    break;
            }

            if (window.innerWidth < 821 && $('#snize-mobile-search-input').length) {
                input = $('#snize-mobile-search-input');
            }

            if (!$(input).prop('value') && fixedList && sectionLabel && sectionNumber != -1 && elementClass) {
                if (!$(`#snize-ac-items-container-${sectionNumber + 1}`, container).length) {
                    $(`#snize-ac-items-container-${sectionNumber}`, container).after(`<ul class="snize-ac-results-list" id="snize-ac-items-container-${sectionNumber + 1}"></ul>`);
                } else {
                    $(`#snize-ac-items-container-${sectionNumber + 1}`, container).removeClass('snize-hidden');
                }

                $(`#snize-ac-items-container-${sectionNumber + 1}`, container).empty();

                $(`#snize-ac-items-container-${sectionNumber + 1}`, container).append(`<li id="snize-${section}-label" class="snize-label" aria-hidden="true">${sectionLabel}</li>`);
                let fixedListEntries = Object.entries(fixedList);
                fixedListEntries.forEach(function(item, index) {
                    $(`#snize-ac-items-container-${sectionNumber + 1}`, container).append(`<li class="snize-${elementClass}" role="button" style="cursor: pointer;" id="snize-${elementClass}-${index}"><a class="snize-view-link" data-no-instant="true" href="${item[1]}">${item[0]}</a></li>`);
                })
            }
        }

        function fixHover() {
            let colorPart = Searchanise.GetWidgets().options.ColorsCSS.split('.snize-ac-over-nodrop')[1];
            let hoverColor = colorPart && colorPart.match(/(?<=#)\D+(?=;)/) && colorPart.match(/(?<=#)\D+(?=;)/)[0] ? '#' + colorPart.match(/(?<=#)\D+(?=;)/)[0] : '#EEEEEE'
            $('body').append(`<style>
                .snize-ac-results .snize-category:hover, 
                .snize-ac-results .snize-page:hover {
                    background: ${hoverColor};
                }
            </style>`);
        }
        fixHover();
        
        $(document).on("Searchanise.AutocompleteUpdated", function(event, input, container) {
            showFixedProducts(container, input);
            showFixedSection(container, input, 'categories');
            showFixedSection(container, input, 'pages');
        });

        if (!$('#snize-product-suggestions-styles').length) {
            $('body').append(`<style id="snize-product-suggestions-styles">
                    @media (min-width: 821px) {
                        .snize-custom-product-suggestions.snize-ac-results-multicolumn-list {
                            display: grid;
                            flex-flow: row wrap;
                            list-style-type: none;
                            max-width: unset;
                            grid-auto-flow: column dense;
                            grid-template-rows: repeat(2, 1fr);
                            width: 100%;
                            overflow-x: auto !important;
                            grid-template-columns: repeat(auto-fit, 220px);
                        }

                        .snize-custom-product-suggestions.snize-ac-results-multicolumn-list .snize-label {
                            position: absolute;
                        }

                        .snize-custom-product-suggestions.snize-ac-results-multicolumn-list .snize-product {
                            min-width: 220px;
                        }
                    }
                </style>    
            `);
        }
    })(window.Searchanise.$);
});
function searchSwiperSlider() {
    const sliderSelector = '.searchanise-swiper';
    const section = document.querySelector(sliderSelector);
    if (!section) return;

    const mySwiper = new Swiper(sliderSelector, {
        speed: 800,
        slidesPerView: 2,
        spaceBetween: 10,
        loop: false,
        grid: {
            rows: 3, // default (desktop)
            fill: 'row'
        },
        breakpoints: {
            480: {
                slidesPerView: 2,
                grid: {
                    rows: 2,
                },
                spaceBetween: 10,
            },
            767: {
                slidesPerView: 2,
                grid: {
                    rows: 2,
                },
                spaceBetween: 10,
            },
            1024: {
                slidesPerView: 'auto',
                grid: {
                    rows: 2,
                },
                spaceBetween: 10,
            }
        },
        scrollbar: {
            el: '.carousel-scrollbar',
            draggable: true,
            hide: false,
        },
        navigation: {
            nextEl: '.pager-next',
            prevEl: '.pager-prev',
        },
        on: {
            afterInit(swiper) {
                const interval = setInterval(() => {
                    const scrollbarDrag = section.querySelector('.swiper-scrollbar-drag');
                    if (scrollbarDrag) {
                        const dragWidth = scrollbarDrag.offsetWidth;
                        if (dragWidth === 0) {
                            swiper.update();
                        } else {
                            clearInterval(interval);
                        }
                    }
                }, 100);
            },
            slideChange: function() {
                if (window.innerWidth < 1024) return;
                let indexValue = (this.activeIndex + 1) * 3;
                const isLastSlide = indexValue === this.slides.length;
                const progressBar = document.querySelector('.searchanise-swiper .carousel-scrollbar .swiper-scrollbar-drag');
                const scrollbar = document.querySelector('.searchanise-swiper .carousel-scrollbar');
                const nextBtn = document.querySelector('.searchanise-swiper .pager-next');
                const scrollbarWidth = scrollbar.offsetWidth;
                const dragWidth = progressBar.offsetWidth;

                // Calculate how far the scrollbar should move
                const maxTranslate = scrollbarWidth - dragWidth;
                if (isLastSlide) {
                    if (progressBar) {
                        progressBar.style.transform = `translate3d(${maxTranslate}px, 0, 0)`;
                    }

                    // Disable next button
                    if (nextBtn) {
                        nextBtn.classList.add('swiper-button-disabled');
                        nextBtn.setAttribute('disabled', true);
                    }
                } else {
                    if (nextBtn) {
                        nextBtn.classList.remove('swiper-button-disabled');
                        nextBtn.removeAttribute('disabled');
                    }
                }
            }
        }
    });
    console.log("slides", section.querySelector(".carousel-controls"), section);
    if (document.querySelectorAll(".snize-product.swiper-slide").length < 7) {
        section.querySelector(".carousel-controls").style.display = "none";
    }
}




